module.exports = __webpack_public_path__ + "static/img/logo53.59e3d3d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo53.png
// module id = L9hS
// module chunks = 1